import { render, staticRenderFns } from "./charts.vue?vue&type=template&id=35810cc6&scoped=true&"
import script from "./charts.vue?vue&type=script&lang=js&"
export * from "./charts.vue?vue&type=script&lang=js&"
import style0 from "./charts.vue?vue&type=style&index=0&id=35810cc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35810cc6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35810cc6')) {
      api.createRecord('35810cc6', component.options)
    } else {
      api.reload('35810cc6', component.options)
    }
    module.hot.accept("./charts.vue?vue&type=template&id=35810cc6&scoped=true&", function () {
      api.rerender('35810cc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/uikit/charts.vue"
export default component.exports